import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { CreativeContext } from "./CreativeCreation";
const jobTypeOptions = [
  { id: 1, label: "Field Job" },
  { id: 2, label: "Office Job" },
  { id: 3, label: "Work From Home" },
  { id: 4, label: "Industry Job" }
];

const shiftOptions = [
  { id: 1, label: "Day Shift" },
  { id: 2, label: "Night Shift" },
  { id: 3, label: "Rotational" },
];

// Job listings widget form
function Listings({
  company,
  companyName,
  handleshow,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();
  const { setPreview } = useContext(CreativeContext);

  const [image, setImage] = useState("");
  const [imgurl, setImgurl] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  const watchTitle = watch("title", editdata?.head_line || "");
  const watchDescription = watch("description", editdata?.description || "");
  const watchLocation = watch("location", editdata?.gallery?.location || "");
  const watchMinSalary = watch("minSalary", editdata?.gallery?.min_salary || "");
  const watchMaxSalary = watch("maxSalary", editdata?.gallery?.max_salary || "");
  const watchVacancies = watch("vacancies", editdata?.impressions || "");
  const watchButtonEnabled = watch(
    "buttonEnabled",
    editdata?.button_enabled === 1 ? true : false
  );
  const buttonTypeDefault =
    editdata?.button_link && editdata?.text_in_link
      ? "3"
      : editdata?.button_link
      ? "1"
      : editdata?.text_in_link
      ? "2"
      : "1";
  const watchButtonType = watch("buttonType", buttonTypeDefault);
  const watchButtonText = watch("buttonText", editdata?.button_text || "");
  const watchPhone = watch("phone", editdata?.button_link || "");
  const watchChatUrl = watch("chatUrl", editdata?.text_in_link || "");

  const employmentTypeDefaultRaw = `${editdata?.position}` || "";
  const employmentTypeDefault =
    employmentTypeDefaultRaw === "Part Time"
      ? "1"
      : employmentTypeDefaultRaw === "Full Time"
      ? "2"
      : employmentTypeDefaultRaw;
  const watchEmploymentType = watch(
    "employmentType",
    employmentTypeDefault || ""
  );

  useEffect(() => {
    const derivedButtonType =
      watchPhone && watchChatUrl ? "3" : watchPhone ? "1" : watchChatUrl ? "2" : "";
    setPreview(prev => ({
      ...prev,
      sub_type: "job_listings",
      head_line: watchTitle,
      description: watchDescription,
      gallery: {
        ...(prev.gallery || {}),
        location: watchLocation,
        min_salary: watchMinSalary,
        max_salary: watchMaxSalary,
        btn_type: watchButtonEnabled ? derivedButtonType || watchButtonType : "",
      },
      position: watchEmploymentType,
      impressions: watchVacancies,
      img_url: imgurl || editdata?.img_url || "",
      button_enabled: watchButtonEnabled,
      button_type: watchButtonEnabled ? derivedButtonType || watchButtonType : "",
      button_text: watchButtonEnabled ? watchButtonText : "",
      button_link: watchButtonEnabled ? watchPhone || "" : "",
      text_in_link: watchButtonEnabled ? watchChatUrl || "" : "",
    }));
  }, [
    watchTitle,
    watchDescription,
    watchLocation,
    watchMinSalary,
    watchMaxSalary,
    watchEmploymentType,
    watchVacancies,
    watchButtonEnabled,
    watchButtonType,
    watchButtonText,
    watchPhone,
    watchChatUrl,
    imgurl,
    setPreview,
  ]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview(prev => ({
        ...prev,
        sub_type: editdata?.sub_type || "job_listings",
        img_url: editdata?.img_url || editdata?.img_urls || "",
      }));
      setImgurl(editdata?.img_url || editdata?.img_urls || "");
    }
  }, [flag, editdata, setPreview]);

  const handleImage = (e) => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "image/png"
        ) {
          setImage(file);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("image", "");
        }
      } else if (flag === "edit") {
        setImgurl(editdata?.img_urls || "");
        setPreview(prev => ({ ...prev, img_urls: editdata?.img_urls || "" }));
      } else {
        setImgurl("");
        setPreview(prev => ({ ...prev, img_urls: "" }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formData = new FormData();
  formData.append("files", image);

  const uploadImage = async () => {
    try {
      const res = await api({
        url: `/upload/brandImage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.code === 200) {
        setImgurl(res?.data?.data);
        setPreview(prev => ({ ...prev, img_urls: res?.data?.data }));
      } else {
        setValue("image", null);
        setImage("");
        Toast("error", res?.data?.message || "Image upload failed");
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (image) uploadImage();
  }, [image]);

  const onSubmit = async (data) => {
    const derivedButtonType =
      data.phone && data.chatUrl
        ? "3"
        : data.phone
        ? "1"
        : data.chatUrl
        ? "2"
        : "";
    if (flag === "add") {
      handlesubmit(true);
      const obj = {
        company_id: company,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        head_line: data.title,
        description: data.description,
        gallery: {
          location: data.location,
          min_salary: data.minSalary,
          max_salary: data.maxSalary,
          btn_type: data.buttonEnabled ? derivedButtonType : "",
          shift:data.shiftType,
          share_link:data.share_link
        },
        position: data.employmentType,
        impressions: data.vacancies,
        img_urls: imgurl,
        button_enabled: data.buttonEnabled ? true : false,
        button_text: data.buttonEnabled ? data.buttonText : "",
        button_link: data.buttonEnabled ? data.phone || "" : "",
        text_in_link: data.buttonEnabled ? data.chatUrl || "" : "",
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      if (creative_name !== "") {
        try {
          const res = await api({
            url: `/creatives/widget/job_listings`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res?.data?.message || "Create failed");
          }
        } catch (error) {
          console.error(error);
          if (error.response?.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      const obj = {
        creative_id: editdata?.creative_id,
        creative_name: creative_name,
        head_line: data.title,
        description: data.description,
        gallery: {
          location: data.location,
          min_salary: data.minSalary,
          max_salary: data.maxSalary,
          btn_type: data.buttonEnabled ? derivedButtonType : "",
          shift:data.shiftType,
          share_link:data.share_link
        },
        position: data.employmentType,
        impressions: data.vacancies,
        button_enabled: data.buttonEnabled ? true : false,
        button_text: data.buttonEnabled ? data.buttonText : "",
        button_link: data.buttonEnabled ? data.phone || "" : "",
        text_in_link: data.buttonEnabled ? data.chatUrl || "" : "",
         impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      obj.img_urls = imgurl !== "" ? imgurl : editdata?.img_url || editdata?.img_urls;
      try {
        const res = await api({
          url: `/creatives/widget/edit_job_listings`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res?.data?.message || "Edit failed");
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) navigate("/");
      }
    }
  };

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="row">
          <section className="col-12">
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.head_line || ""}
                  placeholder="Enter job title"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <p className="text-red-600">{errors.title.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  defaultValue={editdata?.description || ""}
                  placeholder="Enter job description"
                  {...register("description", {
                    required: "Description is required",
                  })}
                />
                {errors.description && (
                  <p className="text-red-600">{errors.description.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.location || ""}
                  placeholder="Enter job location"
                  {...register("location", { required: "Location is required" })}
                />
                {errors.location && (
                  <p className="text-red-600">{errors.location.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Employment Type</label>
                <div className="d-flex gap-4">
                  {jobTypeOptions.map(job => <div key={job.id} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id={`job_${job.label}`}
                      value={job.id}
                      defaultChecked={employmentTypeDefault === String(job.id)}
                      {...register("employmentType", {
                        required: "Employment type is required",
                      })}
                    />
                    <label htmlFor={`job_${job.label}`} className="form-check-label">{job.label}</label>
                  </div>)}
                </div>
                {errors.employmentType && (
                  <p className="text-red-600">
                    {errors.employmentType.message}
                  </p>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label">Vacancies</label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={editdata?.impressions || ""}
                  placeholder="Enter number of vacancies"
                  {...register("vacancies", {
                    required: "Vacancies are required",
                    min: { value: 1, message: "Minimum 1 vacancy" },
                  })}
                />
                {errors.vacancies && (
                  <p className="text-red-600">{errors.vacancies.message}</p>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Salary (Min)</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.min_salary || ""}
                  placeholder="Enter minimum salary"
                  {...register("minSalary", {
                    required: false,
                  })}
                />
                {errors.minSalary && (
                  <p className="text-red-600">{errors.minSalary.message}</p>
                )}
              </div>
              <div className="col">
                <label className="form-label">Salary (Max)</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.max_salary || ""}
                  placeholder="Enter maximum salary"
                  {...register("maxSalary", {
                    required: false,
                  })}
                />
                {errors.maxSalary && (
                  <p className="text-red-600">{errors.maxSalary.message}</p>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Shift Type</label>
                <div className="d-flex gap-4">
                  {shiftOptions.map(shift => <div key={shift.id} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id={`shift_${shift.label}`}
                      value={shift.id}
                      defaultChecked={String(editdata?.gallery?.shift) === String(shift.id)}
                      {...register("shiftType", {
                        required: "Shift type is required",
                      })}
                    />
                    <label htmlFor={`shift_${shift.label}`} className="form-check-label">{shift.label}</label>
                  </div>)}
                </div>
                {errors.shiftType && (
                  <p className="text-red-600">{errors.shiftType.message}</p>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Share URL</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.share_link || ""}
                  placeholder="Enter Share URL"
                 {...register("share_link", {
                    required: "Share URL is required",
                    pattern: {
                      value: /^https:\/\/way2newsapp\.com\/(listing|job)-ad-[A-Za-z0-9+/=]+$/,
                      message: "Enter a valid Way2App listing/job URL"
                    }
                  })}
                />
                {errors.share_link && (
                  <p className="text-red-600">{errors.share_link.message}</p>
                )}
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-12">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  className="form-control"
                  {...register("image", {
                    required: editdata?.img_url || editdata?.img_urls ? false : true,
                    onChange: (e) => handleImage(e),
                  })}
                />
                {!editdata?.img_url && !editdata?.img_urls && errors.image && (
                  <p className="text-red-600">Image is required</p>
                )}
                <p>{imgurl || editdata?.img_url || editdata?.img_urls}</p>
              </div>
            </div>
            <div className="row mb-2">
                 <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
            </div>
            <div className="row mb-2">
              <div className="col">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="Button"
                    defaultChecked={flag === "edit" ? editdata?.button_enabled === 1 : true}
                    {...register("buttonEnabled")}
                  />
                  <label htmlFor="Button" className="form-check-label">Enable Button</label>
                </div>
              </div>
            </div>

            {watchButtonEnabled && (
              <>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Type</label>
                    <div className="d-flex gap-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="btn_call"
                          value="1"
                          defaultChecked={buttonTypeDefault === "1"}
                          {...register("buttonType", {
                            required: "Button type is required",
                          })}
                        />
                        <label htmlFor="btn_call" className="form-check-label">
                          Call
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="btn_whatsapp"
                          value="2"
                          defaultChecked={buttonTypeDefault === "2"}
                          {...register("buttonType", {
                            required: "Button type is required",
                          })}
                        />
                        <label
                          htmlFor="btn_whatsapp"
                          className="form-check-label"
                        >
                          WhatsApp
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="btn_both"
                          value="3"
                          defaultChecked={buttonTypeDefault === "3"}
                          {...register("buttonType", {
                            required: "Button type is required",
                          })}
                        />
                        <label htmlFor="btn_both" className="form-check-label">
                          Both
                        </label>
                      </div>
                    </div>
                    {errors.buttonType && (
                      <p className="text-red-600">
                        {errors.buttonType.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Text</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata?.button_text || ""}
                      placeholder="Enter button text"
                      {...register("buttonText", {
                        required: "Button text is required",
                      })}
                    />
                    {errors.buttonText && (
                      <p className="text-red-600">
                        {errors.buttonText.message}
                      </p>
                    )}
                  </div>
                </div>


                {(watchButtonType === "1" || watchButtonType === "3") && (
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata?.button_link || ""}
                        placeholder="Enter phone number"
                        {...register("phone", {
                          required: "Phone number is required",
                          pattern: {
                            value: /^(0\d{10}|[6-9]\d{9})$/,
                            message: "Enter a valid phone number",
                          },
                        })}
                      />
                      {errors.phone && (
                        <p className="text-red-600">
                          {errors.phone.message}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {(watchButtonType === "2" || watchButtonType === "3") && (
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">WhatsApp Link</label>
      <input
        type="text"
        className="form-control"
        defaultValue={editdata?.text_in_link || ""}
        placeholder="https://wa.me/919876543210"
        {...register("chatUrl", {
          required: "WhatsApp link is required",
          pattern: {
            value: /^(https?:\/\/)?(wa\.me\/|api\.whatsapp\.com\/send\?phone=)[1-9]\d{5,15}$/,
            message: "Please enter a valid WhatsApp link (e.g., https://wa.me/919876543210)",
          },
        })}
      />
      {errors.chatUrl && (
        <p className="text-danger mt-1 small">
          {errors.chatUrl.message}
        </p>
      )}
    </div>
  </div>
)}
              </>
            )}

            <div className="my-3 text-end">
              <button type="submit" className="btn btn-primary">
                Save Creative
              </button>
            </div>
          </section>
        </div>
      </form>
    </div>
  );
}

export default Listings;
